import { renderCoupon, renderPrincipal } from '../../../../components/tables/table-column-renderers'
import { sortBooleanColumn, sortNumericColumn } from '../../../../components/tables/utils'
import { renderIsCompliant } from '../IsCompliant'

export const maturityCompliancesTableColumns = [
  { title: 'Label', dataIndex: 'label' },
  { title: 'Trades', dataIndex: 'tradesCount', sorter: sortNumericColumn({ dataIndex: 'tradesCount' }) },
  {
    title: 'Invested ($)',
    dataIndex: 'amountInvested',
    sorter: sortNumericColumn({ dataIndex: 'amountInvested' }),
    render: renderPrincipal,
  },
  {
    title: 'Available ($)',
    dataIndex: 'amountAvailable',
    sorter: sortNumericColumn({ dataIndex: 'amountAvailable' }),
    render: renderPrincipal,
  },
  {
    title: 'Off ($)',
    dataIndex: 'offLimit',
    sorter: sortNumericColumn({ dataIndex: 'offLimit' }),
    render: renderPrincipal,
  },
  {
    title: 'Is Compliant',
    dataIndex: 'isCompliant',
    render: renderIsCompliant,
    sorter: sortBooleanColumn({ dataIndex: 'isCompliant' }),
  },
  { title: 'Share', dataIndex: 'investmentSharePct', render: renderCoupon },
  { title: 'Max (%)', dataIndex: 'maxLimitPct', sorter: sortNumericColumn({ dataIndex: 'maxLimitPct' }) },
  { title: 'Min (%)', dataIndex: 'minLimitPct', sorter: sortNumericColumn({ dataIndex: 'minLimitPct' }) },
]
